import { queryOptions } from '@tanstack/react-query'

import { fetchDispatches, type FetchDispatchesQuery } from '../api'
import { vehicleDispatchBoardsQueryKeys } from '../query-keys'

export const getDispatchesQueryOptions = (query: FetchDispatchesQuery) => {
  return queryOptions({
    queryKey: vehicleDispatchBoardsQueryKeys.list(query),
    queryFn: async ({ signal }) => fetchDispatches(query, signal)
  })
}
